import React, { Component } from "react";
import { connect } from "react-redux";
import Rdx from "../../../redux/Rdx";

import AreaProperties from "./AreaProperties";
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import HotDeskArea from "./HotDeskArea";
import HotDeskAreaDetails from "./HotDeskAreaDetails";
import OfficePlan from "../../base/OfficePlan";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";
import Skeleton from "react-loading-skeleton";

import ListHeader from "../common/ListHeader";

// Styled Components
import { ContentWrapper } from "../../styles/Work/workBar";
import { Panel } from "../../styles/Common/panel";
import { EmptyListMessage } from "../../styles/Common/emptyListMessage";

// calcite-react
import Button from "calcite-react/Button";
import PlusIcon from "calcite-ui-icons-react/PlusIcon";

class HotDesksPanel extends Component {
  _mounted = false;

  constructor(props) {
    super(props);
    this.state = component.newState({
      areas: null
    });
  }

  addClicked = () => {
    const i18n = Context.instance.i18n;
    AreaProperties.showModal({
      caption: i18n.spaceplanner.hotdeskAreas.addArea,
      areaType: this.getAreaType()
    });
  };


  backClicked = event => {
    // reset the currently selected active item
    const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
    Rdx.setValue(this, rdxActiveAreaKey, null);
  };

  componentDidMount() {
    this._mounted = true;
    this.queryAreas();

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, params => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          this.queryAreas();
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  getAreaType = () => {
    return OfficePlan.SpaceAssignmentTypes.hotdesk;
  };

  getAreaId = areaItem => {
    return aiimUtil.getAttributeValue(areaItem.attributes, FieldNames.AREA_ID);
  };

  queryAreas = () => {
    const officePlan = OfficePlan.getActive();
    officePlan
      .queryHotDeskAreas()
      .then(result => {
        if (!this._mounted) return;
        this.setState({ areas: result });
      })
      .catch(ex => {
        console.warn("Error querying hot desk areas:");
        console.error(ex);
        if (!this._mounted) return;
        Topic.publishErrorAccessingData();
      });
  };

  renderHeader = () => {
    const { rdxActiveAreaId } = this.props;
    const i18n = Context.instance.i18n;
    return rdxActiveAreaId ? (
      <ListHeader backClicked={this.backClicked}></ListHeader>
    ) : (
      <ListHeader
        title={i18n.spaceplanner.hotdeskAreas.caption}
        button={this.renderAddButton()}
      ></ListHeader>
    );
  };

  renderContent = () => {
    const { rdxActiveAreaId } = this.props;
    if (rdxActiveAreaId) {
      const { areas } = this.state;
      if (areas !== null) {
        const foundItem = areas.find(areaItem => {
          return this.getAreaId(areaItem) === rdxActiveAreaId;
        });
        return foundItem ? <HotDeskAreaDetails areaItem={foundItem} /> : null;
      } else {
        return null;
      }
    } else {
      return this.renderAreas();
    }
  };

  render() {
    //const { rdxActiveAreaId } = this.props;
    return (
      <Panel>
        {this.renderHeader()}
        <ContentWrapper areas style={{overflowY:"scroll"}}>{this.renderContent()}</ContentWrapper>
      </Panel>
    );
  }

  renderAddButton = () => {
    const i18n = Context.instance.i18n;
    // {i18n.spaceplanner.hotdeskAreas.addArea}
    return (
      <Button
        onClick={this.addClicked}
        icon={<PlusIcon size={16} />}
        iconPosition="before"
      >
        {i18n.general.add}
      </Button>
    );
  };

  renderAreas = () => {
    const { areas } = this.state;
    if (areas !== null && areas.length > 0) {
      const oidField = OfficePlan.getActive().areasTable.table.objectIdField;
      return areas.map(area => {
        return this.renderArea(area,oidField);
      });
    } else if (areas !== null && areas.length === 0) {
      return (
        <EmptyListMessage>
          {Context.instance.i18n.spaceplanner.hotdeskAreas.noneInList}
        </EmptyListMessage>
      );
    } else {
      return <Skeleton count={10} height={50} />;
    }
  };

  renderArea = (area,oidField) => {
    const id = aiimUtil.getAttributeValue(area.attributes, FieldNames.AREA_ID);
    const oid = aiimUtil.getAttributeValue(area.attributes, oidField);
    return <HotDeskArea key={id+"_"+oid} areaItem={area} />;
  };
}

const mapStateToProps = (state, ownProps) => {
  const rdxActiveAreaKey = Rdx.Keys.ACTIVE_HOTDESK_AREA_ID;
  return {
    rdxActiveAreaId: Rdx.getValue(state, rdxActiveAreaKey)
  };
};

export default connect(mapStateToProps)(HotDesksPanel);
